import "unfetch/polyfill";

const handleError = function (response) {
  if (response.ok) {
    return response;
  } else {
    throw Error(`${response.status} (${response.statusText})`);
  }
};

export class FetchAdapter {
  static get(url, config = {}) {
    const options = Object.assign(config, {
      method: "GET",
      credentials: "include",
    });

    return FetchAdapter.rawFetch(url, options).then(handleError);
  }

  static post(url, config = {}) {
    const options = Object.assign(config, {
      method: "POST",
      credentials: "include",
    });

    return FetchAdapter.rawFetch(url, options).then(handleError);
  }

  static rawFetch(url = "", options = {}) {
    return fetch(url, options);
  }
}
